import { F, useEditor } from 'tldraw'
import { useEditorDeepLink } from '../../../hooks/useDeepLink'
import { useTldrawAppUiEvents } from '../../../utils/app-ui-events'
import { copyTextToClipboard } from '../../../utils/copy'
import { TlaMenuSection } from '../../tla-menu/tla-menu'
import { TlaShareMenuCopyButton } from '../file-share-menu-primitives'
import { QrCode } from '../QrCode'

export function TlaAnonCopyLinkTab() {
	const url = useEditorDeepLink() ?? ''
	return (
		<TlaMenuSection>
			<TlaAnonCopyLinkButton url={url} />
			<QrCode url={url} />
		</TlaMenuSection>
	)
}

/* ---------------------- Share --------------------- */

function TlaAnonCopyLinkButton({ url }: { url: string }) {
	const editor = useEditor()
	const trackEvent = useTldrawAppUiEvents()

	const handleCopyLinkClick = () => {
		copyTextToClipboard(editor.createDeepLink({ url }).toString())
		// no toasts please
		trackEvent('copy-share-link', { source: 'file-share-menu' })
	}

	return (
		<TlaShareMenuCopyButton onClick={handleCopyLinkClick}>
			<F defaultMessage="Copy link" />
		</TlaShareMenuCopyButton>
	)
}
